/**
 * Authenticated fetch wrapper v2.3
 * Automatically adds Authorization header to all requests
 * Auto-redirects to login on 401/403 errors
 * Updated: 2025-12-23
 */

import { BASE_URL } from '@/config/env'

export const authFetch = async (url: string | URL | Request, options: RequestInit = {}): Promise<Response> => {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken')
  
  // Check if body is FormData (for file uploads)
  const isFormData = options.body instanceof FormData
  
  // Start with provided headers
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  }
  
  // Set Content-Type ONLY if not FormData and not already set
  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json'
  }
  
  // Always add Authorization header if token exists (overwrites any existing)
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  
  // Call original fetch with merged headers
  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include', // Send cookies/session with request
  })
  
  // Check for authentication errors
  if (response.status === 401 || response.status === 403) {
    console.warn('[authFetch] Authentication failed (401/403)')
    
    // Skip redirect if we're on the same domain as BASE_URL (development/production mode)
    const currentOrigin = window.location.origin
    const baseOrigin = BASE_URL
    
    // Also check for localhost
    if (currentOrigin === baseOrigin || window.location.hostname.includes('localhost')) {
      return response
    }
    
    console.warn('[authFetch] Redirecting to login...')
    
    // Clear stored tokens
    localStorage.removeItem('token')
    localStorage.removeItem('authToken')
    
    // Redirect to login page if not already there
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login'
    }
  }
  
  return response
}
